export type TRedirectToCallbackParams = {
  accessToken: string;
  refreshToken?: string;
  token: string;
  jwtCallbackUrl: string;
  backPath?: string;
};

const createInput = (name: string, value: string): HTMLInputElement => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.readOnly = true;
  input.name = name;
  input.value = value;

  return input;
};

export const redirectToCallback = ({
  jwtCallbackUrl,
  accessToken,
  refreshToken,
  token,
  backPath,
}: TRedirectToCallbackParams) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = jwtCallbackUrl;

  const accessTokenInput = createInput('access_token', accessToken);
  form.appendChild(accessTokenInput);

  if (refreshToken) {
    const refreshTokenInput = createInput('refresh_token', refreshToken);
    form.appendChild(refreshTokenInput);
  }

  if (backPath) {
    const backPathInput = createInput('back_path', backPath);
    form.appendChild(backPathInput);
  }

  const tokenInput = createInput('token', token);
  form.appendChild(tokenInput);

  document.body.appendChild(form);
  form.submit();
};
